export default __webpack_public_path__ + "30d50812f514492f771a570b0c01e303.svg";